"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;
var _index = require("../../styles/index.js");
var _index2 = require("../TypeListItem/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var ListItem = exports.ListItem = (0, _styledComponents["default"])(_index2.TypeListItem).attrs({
  variant: 'bodyMedium',
  condensed: true,
  listStyleReset: true
}).withConfig({
  displayName: "ListItem",
  componentId: "sc-qa47qy-0"
})(["", ";overflow-wrap:break-word;"], (0, _index.rootStyle)());